import type { PDFPageProxy } from 'pdfjs-dist'

const IMAGE_OBJ_ID_PREFIX = 'img_'

/**
 * When an image decoder fails, pdf.js resolves that image object to `null` and
 * the canvas silently skips the draw — `page.render()` still succeeds, so a
 * page can come back complete except for missing raster content. Counting the
 * null image objects after a render is the only signal that happened.
 *
 * Must be called *after* a render pass; image objects are populated as the page
 * is drawn.
 */
export default function countUndecodedImages(page: PDFPageProxy): number {
  let count = 0

  for (const [objId, data] of page.objs as Iterable<[string, unknown]>) {
    if (objId.startsWith(IMAGE_OBJ_ID_PREFIX) && !data) {
      count++
    }
  }

  return count
}
